"use client"

import React, { useState } from "react"
import { ChevronDown } from "lucide-react"

export function Accordion({ children, type = "single", collapsible = false, className = "" }) {
  return <div className={className}>{children}</div>
}

export function AccordionItem({ children, value, className = "" }) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className={`border-b ${className}`}>
      {React.Children.map(children, (child) => {
        if (child.type === AccordionTrigger) {
          return React.cloneElement(child, {
            isOpen,
            onClick: () => setIsOpen(!isOpen),
          })
        }
        if (child.type === AccordionContent) {
          return React.cloneElement(child, { isOpen })
        }
        return child
      })}
    </div>
  )
}

export function AccordionTrigger({ children, isOpen, onClick, className = "" }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex w-full items-center justify-between py-4 font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-180 ${className}`}
    >
      {children}
      <ChevronDown className={`h-4 w-4 shrink-0 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`} />
    </button>
  )
}

export function AccordionContent({ children, isOpen, className = "" }) {
  return (
    <div
      className={`overflow-hidden text-sm transition-all ${isOpen ? "animate-accordion-down" : "animate-accordion-up h-0"}`}
    >
      <div className={`pb-4 pt-0 ${className}`}>{children}</div>
    </div>
  )
}

